import { TFunction } from 'i18next';

import { ClientConfiguration, Permission } from '@Models';
import { SidebarIcons } from '../icons';
import { MenuItem } from '../types';
import { buildDocumentationItems, buildTrainingVideosItem } from './documentation';

/**
 * Logyca flavor menu. Configuration (Masters) → Admin (Users) → Toolkit
 * (docs + videos).
 *
 * Masters is unconditional, as in the default menu rather than the GS1 one:
 * every Logyca client carries one, so there is no account for which the entry
 * would lead to an empty page. The Insights/Eventos external link stays
 * hidden — the resources hub isn't relevant to the logyca audience right now.
 */
const buildLogycaMenu = (configuration: ClientConfiguration | undefined, t: TFunction): MenuItem[] => [
  {
    key: 'configuration',
    label: t('Sidebar.Configuration'),
    icon: SidebarIcons.configuration,
    submenu: [
      {
        key: 'masters',
        label: t('Sidebar.Master'),
        icon: SidebarIcons.file,
        link: '/configuration/masters',
        enabled: true,
      },
    ],
  },
  {
    key: 'admin',
    label: 'Admin',
    icon: SidebarIcons.admin,
    submenu: [
      {
        key: 'users',
        permission: Permission.ManageUsers,
        label: t('Sidebar.Users'),
        icon: SidebarIcons.users,
        link: '/users',
        hideWhenDisabled: true,
        enabled: true,
      },
      {
        key: 'suppliers',
        permission: [Permission.ManageSuppliers, Permission.ViewSuppliers],
        label: t('Sidebar.Suppliers'),
        icon: SidebarIcons.suppliers,
        link: '/suppliers',
        hideWhenDisabled: true,
      },
    ],
  },
  {
    key: 'toolkit',
    label: t('Sidebar.Toolkit'),
    icon: SidebarIcons.toolkit,
    submenu: [
      ...buildDocumentationItems(configuration?.dataRepository, t),
      ...buildTrainingVideosItem(configuration?.resources, t),
    ],
  },
];

export default buildLogycaMenu;
